import { useCallback, useState } from "react";

export const useClipboard = () => {
  const [didCopy, setDidCopy] = useState(false);

  const reset = useCallback(() => {
    setDidCopy(false);
  }, []);

  const copy = useCallback(async (value: string) => {
    await navigator.clipboard.writeText(value);
    setDidCopy(true);
  }, []);

  return { didCopy, copy, reset };
};
